module.exports = __webpack_public_path__ + "img/runicCapacitor.6ad01ac9.png";